// extracted by mini-css-extract-plugin
export default {"emoji-badge":"EmojiBadge_emoji-badge__7Wq4C"};